import React from 'react';
import PropTypes from 'prop-types';
import { Typo, Button, Icon, Spinner } from '@ers/ui';
import { useSelector } from 'react-redux';
import useLazyOpen from '@ers/lazyOpen';
import { getEditUrl } from '@ers/pages/home/Home.selectors';

const EditButton = ({ applicationId }) => {
    const openNewWindow = (link) => window.open(link, '_blank');
    const props = {};
    const url = useSelector((state) => getEditUrl(state, { key: applicationId }));
    const { open, isLoading } = useLazyOpen('EditUrl', 'Home', [applicationId], getEditUrl, openNewWindow,);
    if (url) {
        props.url = url;
    } else if (!isLoading) {
        props.onClick = open;
    }
    return (
        <Button.Secondary {...props} className="btn--edit">
            <Spinner.Loader isLoading={isLoading}>
                <Icon small name="pencil" />
                <Typo.Body>
                    Edytuj
                </Typo.Body>
            </Spinner.Loader>
        </Button.Secondary>
    );
};
EditButton.propTypes = {
    applicationId: PropTypes.number.isRequired,
};
export default EditButton;